import { gql } from "@apollo/client";

const ENVIAR_EMAIL_PROFESIONAL = gql`
    mutation enviarEmailProfesional($idEvaluacionProfesional: Int!){
        enviarEmailProfesional(idEvaluacionProfesional: $idEvaluacionProfesional)
    }
`;

export default ENVIAR_EMAIL_PROFESIONAL;